'use strict';
import * as _ from 'lodash';
import { module } from '../app';
import { constantStrings } from "../constants/constantStrings";
import { LoadDiagramBackground } from "../services/findingsBg";

module.directive('diagramEditor', [ '$rootScope', '$parse', 'scarDrawer', 'safeApply', 'eventsMgr', 'modalService',
  function ($rootScope, $parse, scarDrawer, safeApply, eventsMgr, modalService) {
    return {
      scope: {
        problems: '=',
        zoom: '=',
        saveAction: '=',
        selected: '=',
        getMode: '=',
        drawScar: '=',
        addProblem: '=',
        skipAutoSave: '=',
        setDiagramEditor: '=',
        problemSettings: '=',
        viewOnly: '='
      },
      link: function (scope, elm, attrs) {
        scope.$on('$destroy', () => {
          if (!scope.destroyed) {
            $rootScope.diagramEditorOnStartSaving.unsubscribe();
            $rootScope.diagramEditorOnDeselectItem.unsubscribe();
            $rootScope.onLockDragging.unsubscribe();
            $rootScope.onUnlockDragging.unsubscribe();

            //".dragsuppress-" + ++d3_event_dragId
            // normal event window => 'touchmove'

            for (let i = 0; i < 500; i++) {
              let name = ".dragsuppress-" + i;
              d3.select(window)
                .on("touchmove" + name, null)
                .on("dragstart" + name, null)
                .on("selectstart" + name, null);
            }

            scope.destroyed = true;
          }
        });

        scope.safeApply = function (fn) {
          let phase = this.$root.$$phase;
          if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof(fn) === 'function')) {
              fn();
            }
          } else {
            this.$apply(fn);
          }
        };

        scope.self = {};
        scope.self.currZoom = 0;
        scope.self.currentEl = null;
        scope.self.itemsCount = 0;
        scope.self.svgItems = [];
        scope.self.dragArea = {left: 25, right: 775, top: 70, bottom: 280, rightBorder: 800};
        scope.dragLocked = false;
        // 1 - slow, 10 - fast
        scope.resizeSpeedMultiplier = 3;

        scope.self.paper = d3.select('#' + elm[ 0 ].id)
          .append("svg")
          .attr('id', 'diagram_canvas')
          .attr('width', 800)
          .attr('height', 350);

        let drag = d3.behavior.drag()
          .origin(d => d)
          .on("dragstart", dragstart)
          .on("drag", dragmove)
          .on("dragend", dragend);


        let dragright = d3.behavior.drag()
          .origin(d => d)
          .on("dragstart", rdragstart)
          .on("drag", rdragresize)
          .on("dragend", dragend);

          LoadDiagramBackground(scope.self.paper)
          .then(image => {
            scope.self.image = d3.select(image);
            scope.self.image
                 .moveToBack()
                 .on('click', function () {
                   if (scope.viewOnly) {
                     return;
                   }
                  let mode = scope.getMode();
                  if (scope.self.currentEl) {
                    select(null, {});
                  } else if (!!mode && !isScarType(mode)) {
                    let m = d3.mouse(this);
                    scope.$apply(() => {
                      scope.addProblem(mode, {x: m[ 0 ], y: m[ 1 ]});
                    });
                  }
                 });

            scope.self.scarDrawer = new scarDrawer(scope.self.paper, scope.self.image, drawScar)
          });

        scope.$watch('getMode()', () => {
          if (scope.self.scarDrawer) {
            //console.log('getMode() changed: ', scope.getMode());
            scope.self.scarDrawer.enable(isScarType(scope.getMode()));
          }
        });

        scope.$watchCollection('problems', (newValue, oldValue) => {
          if (scope.problems && scope.problems.length > scope.self.itemsCount) {
            let newItems = scope.problems.slice(scope.self.itemsCount);

            newItems.forEach(item => {
              const effectiveType = getEffectiveType(item);
              if (effectiveType === 'ReductionScar') {
                let allReductionScars = scope.problems.filter(_ => getEffectiveType(_) === 'ReductionScar');

                const anotherReductionScar = scope.problems.find(_ => getEffectiveType(_) === 'ReductionScar' && _.index !== item.index);

                const svgHalfWidth = scope.self.paper.attr('width');
                
                if (anotherReductionScar) {
                  if ((item.Settings.x < svgHalfWidth / 2 && anotherReductionScar.Settings.x < svgHalfWidth / 2 ||
                    item.Settings.x > svgHalfWidth / 2 && anotherReductionScar.Settings.x > svgHalfWidth / 2) || allReductionScars.length > 2) {

                    scope.problems = scope.problems.filter((problem) => {
                      return problem.index !== item.index;
                    });
                    //scope.problems.splice(scope.problems.indexOf(item), 1);
                    modalService.showAlert(constantStrings.errorMessages.multipleReductionScarOnSameBreast);
                    return;
                  }
                }
              }

              if (effectiveType === 'Mastectomy') {
                const otherMastectomy = scope.problems.find(_ => getEffectiveType(_) === 'Mastectomy' && _.index !== item.index);
                let oldMastectomy = scope.problems.filter(_ => getEffectiveType(_) === 'Mastectomy');
                if (otherMastectomy) {
                  if ((item.Settings.x < scope.self.paper.attr('width') / 2 && otherMastectomy.Settings.x < scope.self.paper.attr('width') / 2 ||
                    item.Settings.x > scope.self.paper.attr('width') / 2 && otherMastectomy.Settings.x > scope.self.paper.attr('width') / 2) || oldMastectomy.length > 2) {

                    scope.problems = scope.problems.filter((problem) => {
                      return problem.index !== item.index;
                    });
                    //scope.problems.splice(scope.problems.indexOf(item), 1);                    
                    modalService.showAlert(constantStrings.errorMessages.multipleMastectomiesOnSameBreast);
                    return;
                  }
                }
              }

              let f = drawElement(item);
              scope.self.svgItems.push(f);
            });
            //
            // let el = _.last(scope.self.svgItems);
            // select(el.select('.figure').node(), el.datum());
          }

          if (scope.problems.length === 0 && scope.self.svgItems.length > 0) {
            removeAll();
          }

          if (scope.problems) {
            scope.self.itemsCount = scope.problems.length;
          }
        }, true);

        scope.$watch("zoom", (ev, args) => {
          scope.self.currZoom = scope.zoom;
        });

        scope.$on('$destroy', () => {
          if (scope.skipAutoSave) {
            return;
          }
          select(null, {});
          d3.selectAll('.bartop').remove();
          d3.selectAll('.dragright').remove();
          scope.saveAction((new window.XMLSerializer()).serializeToString(scope.self.paper[ 0 ][ 0 ]));
        });

        if ($rootScope.diagramEditorOnStartSaving) {
          $rootScope.diagramEditorOnStartSaving.unsubscribe();
        }

        if ($rootScope.diagramEditorOnDeselectItem) {
          $rootScope.diagramEditorOnDeselectItem.unsubscribe();
        }

        if ($rootScope.onLockDragging) {
          $rootScope.onLockDragging.unsubscribe();
        }

        if ($rootScope.onUnlockDragging) {
          $rootScope.onUnlockDragging.unsubscribe();
        }

        scope.executeSaveDiagramImage = async () => {
          select(null, {});
          
          appendLegends();

          const svgString = (new window.XMLSerializer()).serializeToString(scope.self.paper[ 0 ][ 0 ]);

          removeLegends();

          return scope.saveAction(svgString, true);
        };

        $rootScope.diagramEditorOnStartSaving = eventsMgr.on('diagram:startSaving', () => {
          return scope.executeSaveDiagramImage();
        });

        scope.self.getSvgImage = async () => {
          return scope.executeSaveDiagramImage();
        };

        $rootScope.diagramEditorOnDeselectItem = eventsMgr.on('diagram:deselectItem', () => {
          select(null, {});
        });

        $rootScope.onLockDragging = eventsMgr.on('diagram:lockDragging', () => {
          scope.dragLocked = true;
        });

        $rootScope.onUnlockDragging = eventsMgr.on('diagram:unlockDragging', () => {
          scope.dragLocked = false;
        });

        setTimeout(() => {
          scope.setDiagramEditor(scope.self);
        }, 0);

        function getEffectiveType(item) {
          if (!scope.problemSettings || !item) {
            return item.Type;
          }
          const problemSetting = scope.problemSettings.find(_ => _.Type === item.Type);
          if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType) {
            return problemSetting.BaseType;
          }
          return item.Type;
        }

        function getItemColor(item) {
          if (!scope.problemSettings || !item) {
            return null;
          }
          const problemSetting = scope.problemSettings.find(_ => _.Type === item.Type);
          if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.Color) {
            return problemSetting.Color;
          }
          return null;
        }

        function isScarType(type) {
          if (!type) {
            return false;
          }
          if (type === 'Scar') {
            return true;
          }
          if (!scope.problemSettings) {
            return false;
          }
          const problemSetting = scope.problemSettings.find(_ => _.Type === type);
          return problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType === 'Scar';
        }

        function select(el, d) {
          if (scope.viewOnly) {
            return;
          }

          let oldEl = scope.self.currentEl;
          scope.self.currentEl = el;
          if (oldEl) {
            redraw(oldEl);
          }

          if (el) {
            redraw(el);
            d3.select(el.parentNode).moveToFront();
          }

          scope.selected = d ? d.item : null;
          safeApply(scope);
        }

        function removeLegends() {
          scope.self.paper.selectAll('#legend-container').remove();
        }

        function appendLegends() {
          let index = 0;
          const renderedLegends = [];
          for (let item of scope.problems) {
            const effectiveType = getEffectiveType(item);
            if (renderedLegends.indexOf(effectiveType) > -1) {
              continue;
            }
            appendLegend(item, index++);
            renderedLegends.push(effectiveType);
          }
        }

        function appendLegend(item, index) {
          const el = scope.self.paper.append('svg:g');
          el.attr('id', 'legend-container');
          if (index === 0) {
            appendLegend.lengthOfLegend = 30;
          }
          const effectiveType = getEffectiveType(item);
          const itemColor = getItemColor(item);
          switch (effectiveType) {
            case "Scar":
              el.append('path')
                .attr('d', 'M29.8,15.1h-4.9v-5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5H9.8V4.3c0-0.6-0.4-1-1-1s-1,0.4-1,1v10.8H1.3c-0.6,0-1,0.4-1,1s0.4,1,1,1\n' +
                  '\th6.4v9.4c0,0.6,0.4,1,1,1s1-0.4,1-1v-9.4h13.1v10.6c0,0.6,0.4,1,1,1s1-0.4,1-1V17.1h4.9c0.6,0,1-0.4,1-1S30.3,15.1,29.8,15.1z')
                .attr('fill', 'none')
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 2)
                .attr('transform', `translate(${appendLegend.lengthOfLegend},10)`)
                .attr('width', 32)
                .attr('height', 32);
                appendLegend.lengthOfLegend += 50;
              break;
            case "Pain":
              el.append('path')
                .attr('d', 'M0 -10L10 10L-10 10L0 -10Z')
                .attr('fill', 'white')
                .attr('fill-opacity', 0)
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 2)
                .attr('transform', `translate(${appendLegend.lengthOfLegend},25)`);
                appendLegend.lengthOfLegend += 30;
              break;
            case "Square":
              el.append('rect')
                .attr('x', -10)
                .attr('y', -10)
                .attr('width', 20)
                .attr('height', 20)
                .attr('stroke-width', 2)
                .attr('stroke', itemColor || 'black')
                .attr('fill', 'transparent')
                .attr('transform', `translate(${appendLegend.lengthOfLegend},25)`);
                appendLegend.lengthOfLegend += 40;
              break;
            case "Mastectomy":
              const legendMastectomyColor = itemColor || 'darkgray';
              el.append('path')
                .attr('d', 'M-110 110L-110 -110L0 0L110 -110L110 110')
                .attr('fill', 'white')
                .attr('fill-opacity', 0)
                .attr('stroke-opacity', 0.5)
                .attr('stroke', legendMastectomyColor)
                .attr('stroke-width', 40)
                .attr('transform', `translate(${appendLegend.lengthOfLegend},25)scale(0.07)`);
                appendLegend.lengthOfLegend += 55;
              break;
            case 'Mole':
              el.append('circle')
                .attr('r', 10).attr('fill', itemColor || 'black').attr('stroke-width', 3)
                .attr('transform', `translate(${appendLegend.lengthOfLegend},25)`);
                appendLegend.lengthOfLegend += 35;
              break;
            case 'Lump':
              el.append('circle').attr('r', 10).attr('stroke-width', 2).attr('stroke', itemColor || 'black').attr('fill', 'transparent')
                .attr('transform', `translate(${appendLegend.lengthOfLegend},25)`);
                appendLegend.lengthOfLegend += 35;
              break;
            case 'CircularScar':
              height = 50.93;
              width = 50.93;

              const pathData = `M24.4,0c0,13.5-10.9,24.4-24.4,24.4S-24.5,13.5-24.5,0S-13.5,-24.4,0,-24.4S24.4,-13.5,24.4,0z
                M28.6,0h-8.5 M-20.2,0h-8.5 M-0.1,-28.7v8.5 M-0.1,20.1v8.5
                M20.2,-20.3l-6,6 M-14.3,14.2l-6,6 M-20.3,-20.3l6,6 M14.2,14.2l6,6 M26.4,-11l-7.9,3.3 M-18.7,7.7L-26.5,11 M-11, -26.5l3.3,7.9
                M7.7,18.6l3.3,7.9 M26.4,11l-7.9-3.3 M-18.7,-7.7L-26.5,-11 M10.9,-26.5l-3.3,7.9 M-7.8,18.6L-11,26.5`;

              el.append('svg:path')
                  .attr('d', pathData)
                  .attr('stroke-width', '2.5')
                  .attr('stroke', itemColor || 'black')
                  .attr('fill', 'transparent')
                  .attr('transform', `translate(${appendLegend.lengthOfLegend},25)scale(0.8)`)
                  .attr('class', 'dragHandle figure');

              appendLegend.lengthOfLegend += 80;
              break;
            case 'ReductionScar':
              el.append('svg:path')
                .attr('d', 'M74.9,42.5c0,13.5-10.9,24.4-24.4,24.4S26,56,26,42.5S37,18.1,50.5,18.1S74.9,29,74.9,42.5z\n' +
                  '\t M50.4,66.9v43.3 M46.2,68.4h8.5 M46.2,72.4h8.5 M46.2,76.4h8.5 M46.2,80.4h8.5 M46.2,84.4h8.5 M46.2,88.4h8.5 M46.2,92.4h8.5\n' +
                  '\t M46.2,96.4h8.5 M46.2,100.4h8.5 M46.2,104.4h8.5 M46.2,108.4h8.5 M79.1,42.5h-8.5 M30.3,42.5h-8.5 M50.4,13.8v8.5 M50.4,62.6v8.5\n' +
                  '\t M70.7,22.2l-6,6 M36.2,56.7l-6,6 M30.2,22.2l6,6 M64.7,56.7l6,6 M76.9,31.5l-7.9,3.3 M31.8,50.2L24,53.5 M39.5,16l3.3,7.9\n' +
                  '\t M58.2,61.1l3.3,7.9 M76.9,53.5l-7.9-3.3 M31.8,34.8L24,31.5 M61.4,16l-3.3,7.9 M42.7,61.1L39.5,69 M8.7,98.1\n' +
                  '\tc6.2,3.8,21.4,12,42.4,12c21.2,0,36.5-8.2,42.6-12 M50.4,105.8v8.5 M91.2,94.7l5.2,6.7 M11.4,94.7l-5.2,6.7 M18.4,98.5l-4.3,7.4\n' +
                  '\t M82.8,99.1l4.3,7.4 M74.9,102.1l3.3,7.9 M26.1,101.6l-3.3,7.9 M66.9,104.2l2.2,8.2 M34.1,103.9l-2.2,8.2 M58.6,105.4l1.1,8.4\n' +
                  '\t M42.2,105.3l-1.1,8.4')
                .attr('fill', 'transparent')
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 1.5)
                .attr('transform', `translate(${appendLegend.lengthOfLegend},10)scale(0.25)`);
                appendLegend.lengthOfLegend += 80;
              break;
          }

          el.append("text")
            .attr('class', 'barLabel')
            .attr("dx", appendLegend.lengthOfLegend)
            .attr("dy", 30)
            .attr("text-anchor", "middle")
            .text((d) => {
              const currentElementSettings = scope.problemSettings.find(_ => _.Type === item.Type);
              if (currentElementSettings) {
                if (currentElementSettings.Label) {
                  return currentElementSettings.Label;
                }
                if (currentElementSettings.IsManuallyAdded) {
                  return currentElementSettings.Type;
                }
                return currentElementSettings.Type === 'ReductionScar' ? 'Reduction Scar' : currentElementSettings.Type;
              }
              return item.Type;
            });
            appendLegend.lengthOfLegend += effectiveType.length * 4 + 40;
        }

        function drawElement(item) {
          const el = scope.self.paper.append('svg:g');
          let height, width;
          const effectiveType = getEffectiveType(item);
          const itemColor = getItemColor(item);
          switch (effectiveType) {
            case 'Mole':
              el.append('circle').attr('r', 10).attr('fill', itemColor || 'black').attr('stroke-width', 3).attr('class', 'dragHandle figure');
              height = width = 20;
              break;
            case 'Lump':
              el.append('circle').attr('r', 10).attr('stroke-width', 2).attr('stroke', itemColor || 'black').attr('fill', 'transparent').attr('class', 'dragHandle figure');
              height = width = 36;
              break;
            case 'Square':
              height = width = 20;
              el.append('rect')
                .attr('x', -width / 2)
                .attr('y', -height / 2)
                .attr('width', width)
                .attr('height', height)
                .attr('stroke-width', 2)
                .attr('stroke', itemColor || 'black')
                .attr('fill', 'transparent')
                .attr('class', 'dragHandle figure');
              break;
            case 'Scar':
              height = item.Settings.height;
              width = item.Settings.width;

              if (!!item.Settings.path) {
                el.append('rect')
                  .attr('x', -width / 2)
                  .attr('y', -height / 2)
                  .attr('width', width).attr('height', height)
                  .attr('fill', 'white')
                  .attr('opacity', 0)
                  .attr('class', 'dragHandle2');

                el.append("path")
                  .data([ item.Settings.path ])
                  .attr("class", "dragHandle figure")
                  .attr("d", getLine())
                  .attr('fill', 'none')
                  .attr('stroke', itemColor || 'black')
                  .attr('stroke-width', 3);
              }

              break;
            case 'Pain':
              height = 20;
              width = 20;
              el.append('svg:path')
                .attr('d', 'M0 -10L10 10L-10 10L0 -10Z')
                .attr('fill', 'white')
                .attr('fill-opacity', 0)
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 2)
                .attr('class', 'dragHandle figure');
              break;
            case 'Star':
              item.Settings.scale = item.Settings.scale || 2;
              height = 20;
              width = 20;

              el.append('svg:path')
                .attr('d', 'M0 -11.4L2.9 -2.8L11.9 -2.8L4.7 2.6L7.3 11.2L0 6.1L-7.3 11.2L-4.7 2.6L-11.9 -2.8L-2.9 -2.8Z')
                .attr('fill', 'white')
                .attr('fill-opacity', 0)
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 0.5)
                .attr('class', 'dragHandle figure');
              break;
            case 'Mastectomy':
              height = width = 230;
              if (item.Settings.x < scope.self.paper.attr('width') / 2) {
                item.Settings.x = scope.self.paper.attr('width') / 3.63;
              } else {
                item.Settings.x = scope.self.paper.attr('width') / 4 * 3;
              }
              item.Settings.y = scope.self.paper.attr('height') / 2;

              const mastectomyColor = itemColor || 'darkgray';
              el.append('svg:path')
                .attr('d', 'M-130 90L-130 -70L0 0L110 -70L110 90')
                .attr('fill', 'white')
                .attr('fill-opacity', 0)
                .attr('stroke-opacity', 0.5)
                .attr('stroke', mastectomyColor)
                .attr('stroke-width', 40);

              el.append('rect')
                .attr('rx', 6).attr('ry', 6)
                .attr('x', -width / 2 * 1.7).attr('y', -height / 2)
                .attr('width', width * 1.6).attr('height', height * 1.1 - 30)
                .attr('stroke', mastectomyColor)
                .attr('fill-opacity', 0).attr('stroke-opacity', 0.2)
                .attr('class', 'figure selectProblem');

              break;
            case 'CircularScar':
              height = 50.93;
              width = 50.93;

              const pathData = `M24.4,0c0,13.5-10.9,24.4-24.4,24.4S-24.5,13.5-24.5,0S-13.5,-24.4,0,-24.4S24.4,-13.5,24.4,0z
                M28.6,0h-8.5 M-20.2,0h-8.5 M-0.1,-28.7v8.5 M-0.1,20.1v8.5
                M20.2,-20.3l-6,6 M-14.3,14.2l-6,6 M-20.3,-20.3l6,6 M14.2,14.2l6,6 M26.4,-11l-7.9,3.3 M-18.7,7.7L-26.5,11 M-11, -26.5l3.3,7.9
                M7.7,18.6l3.3,7.9 M26.4,11l-7.9-3.3 M-18.7,-7.7L-26.5,-11 M10.9,-26.5l-3.3,7.9 M-7.8,18.6L-11,26.5`;

              el.append('svg:path')
                  .attr('d', pathData)
                  .attr('stroke-width', '2.5')
                  .attr('stroke', itemColor || 'black')
                  .attr('fill', 'transparent')
                  .attr('transform', 'scale(0.8)')
                  .attr('class', 'dragHandle figure');

              break;
            case 'ReductionScar':
              height = 126;
              width = 101;

              if (item.Settings.x < scope.self.paper.attr('width') / 2) {
                item.Settings.x = 231;
                item.Settings.side = 'LEFT';
              } else {
                item.Settings.x = 466;
                item.Settings.side = 'RIGHT';
              }

              item.Settings.y = 161;

              el.append('svg:path')
                .attr('d', 'M74.9,42.5c0,13.5-10.9,24.4-24.4,24.4S26,56,26,42.5S37,18.1,50.5,18.1S74.9,29,74.9,42.5z\n' +
                  '\t M50.4,66.9v43.3 M46.2,68.4h8.5 M46.2,72.4h8.5 M46.2,76.4h8.5 M46.2,80.4h8.5 M46.2,84.4h8.5 M46.2,88.4h8.5 M46.2,92.4h8.5\n' +
                  '\t M46.2,96.4h8.5 M46.2,100.4h8.5 M46.2,104.4h8.5 M46.2,108.4h8.5 M79.1,42.5h-8.5 M30.3,42.5h-8.5 M50.4,13.8v8.5 M50.4,62.6v8.5\n' +
                  '\t M70.7,22.2l-6,6 M36.2,56.7l-6,6 M30.2,22.2l6,6 M64.7,56.7l6,6 M76.9,31.5l-7.9,3.3 M31.8,50.2L24,53.5 M39.5,16l3.3,7.9\n' +
                  '\t M58.2,61.1l3.3,7.9 M76.9,53.5l-7.9-3.3 M31.8,34.8L24,31.5 M61.4,16l-3.3,7.9 M42.7,61.1L39.5,69 M8.7,98.1\n' +
                  '\tc6.2,3.8,21.4,12,42.4,12c21.2,0,36.5-8.2,42.6-12 M50.4,105.8v8.5 M91.2,94.7l5.2,6.7 M11.4,94.7l-5.2,6.7 M18.4,98.5l-4.3,7.4\n' +
                  '\t M82.8,99.1l4.3,7.4 M74.9,102.1l3.3,7.9 M26.1,101.6l-3.3,7.9 M66.9,104.2l2.2,8.2 M34.1,103.9l-2.2,8.2 M58.6,105.4l1.1,8.4\n' +
                  '\t M42.2,105.3l-1.1,8.4')
                .attr('fill', 'transparent')
                .attr('stroke', itemColor || 'black')
                .attr('stroke-width', 2)
                .attr('class', 'figure reduction-scar');
              break;
          }


          el.datum({
            x: Math.max(scope.self.dragArea.left, Math.min(item.Settings.x, scope.self.dragArea.right)),
            y: Math.max(scope.self.dragArea.top, Math.min(item.Settings.y, scope.self.dragArea.bottom)),
            path: item.Settings.path,
            width: width,
            height: height,
            origWidth: width,
            origHeight: height,
            scale: item.Settings.scale || 1,
            item: item
          });

          setTimeout(() => {
            el.select('.dragHandle2, .dragHandle').call(drag);
          }, 150);
          el.moveToFront();

          let handleSize = 12;
          let handleDistance = 25;
          if (effectiveType !== 'Mastectomy' && effectiveType !== 'ReductionScar') {
            let dragbarright = el.append("g")
              .attr("class", "dragright")
              .attr('stroke', 'black')
              .attr('fill', 'white')
              .attr("fill-opacity", .5)
              .attr("cursor", "ew-resize")
              .call(dragright);

            dragbarright.append('circle')
              .attr('r', handleSize)
              .attr('cx', width / 2 + handleDistance);

            let dragBarX = width / 2 + handleDistance;
            dragbarright.append('path')
              .data([
                [
                  [ dragBarX - 6, -2 ],
                  [ dragBarX - 6, -6 ],
                  [ dragBarX - 2, -6 ],
                  [ dragBarX - 6, -6 ],
                  [ dragBarX + 6, 6 ],
                  [ dragBarX + 6, 2 ],
                  [ dragBarX + 6, 6 ],
                  [ dragBarX + 2, 6 ]
                ]
              ])
              .attr("class", "dragHandle")
              .attr("d", getLine())
          }

          let bartop = el.append("g")
            .attr("class", "bartop")
            .attr('stroke', 'black')
            .attr('fill', 'white')
            .attr("fill-opacity", .5)
            .on('click', () => removeElement(el));

          bartop.append('circle')
            .attr('r', handleSize)
            .attr('cy', -height / 2 - handleDistance);

          bartop.append('path')
            .attr('d', 'M-6 ' + (-height / 2 - handleDistance + 6) + 'L6' + (-height / 2 - handleDistance - 6) +
              'M6 ' + (-height / 2 - handleDistance + 6) + 'L-6' + (-height / 2 - handleDistance - 6));

          el.append("text")
            .attr('class', 'barLabel')
            .attr("dy", ".35em")
            .attr("text-anchor", "middle")
            .text((d) => d.item.index);

          el.select('.dragHandle, .dragHandle2, .dragright, .figure').on('click', dragend);

          redraw(el.select('.figure').node());

          return el;
        }

        function getPosition(item) {
          let data = item.datum();
          return {
            x: data.x,
            y: data.y,
            scale: data.scale,
            path: data.path,
            width: data.origWidth,
            height: data.origHeight,
          };
        }

        function dragstart(d) {
          const effectiveType = getEffectiveType(d.item);
          let mousePoint = effectiveType === 'Scar' ? d3.getMousePoint(this, d) : d3.mouse(this);

          d.dragstart = mousePoint; // store this
          d.widthstart = d.width;
          d.started = true;
          select(this, d);
        }

        async function dragmove(d) {

          if (scope.dragLocked || !d.started || !scope.self.currentEl) {
            return;
          }
          
          const currentItem = d3.select(scope.self.currentEl).datum().item;
          const dragItem = d.item;
          
          let isSameItem = false;
          if (currentItem.Id !== undefined && currentItem.Id !== null && 
              dragItem.Id !== undefined && dragItem.Id !== null) {
            isSameItem = currentItem.Id === dragItem.Id;
          } else {
            const currentEffectiveType = getEffectiveType(currentItem);
            const dragEffectiveType = getEffectiveType(dragItem);
            isSameItem = currentEffectiveType === dragEffectiveType &&
                         currentItem.Settings && dragItem.Settings &&
                         currentItem.Settings.x === dragItem.Settings.x &&
                         currentItem.Settings.y === dragItem.Settings.y &&
                         currentItem.index === dragItem.index;
          }
          
          if (!isSameItem) {
            return;
          }

          let rX = d.rX || (d.rX = d.origWidth * d.scale / 2);
          let rY = d.rY || (d.rY = d.height * d.scale / 2);

          const effectiveType = getEffectiveType(d.item);
          let mousePoint = effectiveType === 'Scar' ? d3.getMousePoint(this, d) : d3.mouse(this);

          const x = d.x + mousePoint[ 0 ] - d.dragstart[ 0 ];
          const y = d.y + mousePoint[ 1 ] - d.dragstart[ 1 ];

          d.x = Math.max(rX + scope.self.dragArea.left, Math.min(x, scope.self.dragArea.right - rX));
          d.y = Math.max(rY + scope.self.dragArea.top, Math.min(y, scope.self.dragArea.bottom - rY));
          await redraw(this);
        }

        function dragend(d) {          
          if (scope.viewOnly) {
            return;
          }
          select(this, d);
          d.started = false;
          d.rX = null;
          d.rY = null;
          d3.event.preventDefault ?
            d3.event.preventDefault() :
            d3.event.sourceEvent.preventDefault();

          setProblemSettings(d.item);
        }

        async function removeElement(el) {
          if (scope.viewOnly) {
            return;
          }
          eventsMgr.send('diagram:clearProblemSelection');
          eventsMgr.send('diagram:lockDragging');
          let confirmed = await modalService.showConfirmation(null, 'Are you sure you want to delete this item?');
          if (!confirmed) {
            eventsMgr.send('diagram:unlockDragging');
          } else {
            const item = el.datum().item;
            const svgElIndex = scope.self.svgItems.indexOf(el);
            scope.self.svgItems = scope.self.svgItems.filter((item, index) => {
              return index !== svgElIndex;
            });
            //scope.self.svgItems.splice(scope.self.svgItems.indexOf(el), 1);

            const itemEffectiveType = getEffectiveType(item);
            scope.problems = scope.problems.filter((problem) => {
              const problemEffectiveType = getEffectiveType(problem);
              return problemEffectiveType !== itemEffectiveType || problemEffectiveType === itemEffectiveType && (problem.Settings.x !== item.Settings.x || problem.Settings.y !== item.Settings.y);
            });
            //scope.problems.splice(scope.problems.indexOf(el.datum().item), 1);

            scope.self.itemsCount = scope.problems.length;
            el.remove();
            select(null, {});

            let index = 1;
            scope.problems.forEach(item => {
              item.index = index;
              index++;
            });
            scope.self.svgItems.forEach(item => {
              redraw(item.select('.figure').node());
            });
            eventsMgr.send('diagram:unlockDragging');
          }
        }

        function removeAll() {
          scope.self.svgItems.slice(0).forEach(el => {
            scope.self.svgItems.splice(scope.self.svgItems.indexOf(el), 1);
            el.remove();
          });

          scope.self.itemsCount = scope.problems.length;
          select(null, {});
        }

        function rdragstart(d) {
          if (scope.viewOnly) {
            return;
          }
          d.dragstart = d3.mouse(this, d); // store this
          d.dragstartAbsolute = d3.mouse(scope.self.paper[ 0 ][ 0 ]);
          d.widthstart = d.width;
          d.started = true;
          select(this, d);
        }

        function rdragresize(d) {
          d.widthstart = d.item.Settings.width * d.scale;

          //Max x on the left is x - width
          //Max x on the right is width of screen + (dragbarw/2)
          let m = d3.mouse(scope.self.paper[ 0 ][ 0 ]);
          let dx = Math.min(m[ 0 ], scope.self.dragArea.rightBorder - 5) - d.dragstartAbsolute[ 0 ];

          const effectiveType = getEffectiveType(d.item);
          let minWidth = effectiveType === 'Scar' ? 35 : 20;
          let dragx = Math.max(minWidth, d.widthstart + dx * scope.resizeSpeedMultiplier * 0.02);

          //console.log(dragx);
          //recalculate width
          d.width = dragx;

          d.scale = Math.min(d.width / d.origWidth, (scope.self.dragArea.bottom - scope.self.dragArea.top) / d.height);
          d.scale = Math.min(d.scale, (scope.self.dragArea.right - scope.self.dragArea.left) / d.origWidth);

          let rX = d.origWidth * d.scale / 2;
          let rY = d.height * d.scale / 2;
          d.x = Math.max(rX + scope.self.dragArea.left, Math.min(d.x, scope.self.dragArea.right - rX));
          d.y = Math.max(rY + scope.self.dragArea.top, Math.min(d.y, scope.self.dragArea.bottom - rY));

          setProblemSettings(d.item);

          redraw(this);
        }

        function setProblemSettings(newProblem){
          scope.problems.forEach(problem => {
            if(problem.Id === newProblem.Id){
              problem.Settings = newProblem.Settings;
            }
          });
        }

        function selected(d) {
          if (!scope.self.currentEl) {
            return false;
          }
          const currentItem = d3.select(scope.self.currentEl).datum().item;
          const compareItem = d.item;
          
          if (currentItem.Id !== undefined && currentItem.Id !== null && 
              compareItem.Id !== undefined && compareItem.Id !== null) {
            return currentItem.Id === compareItem.Id;
          }
          
          const currentEffectiveType = getEffectiveType(currentItem);
          const compareEffectiveType = getEffectiveType(compareItem);
          
          return currentEffectiveType === compareEffectiveType &&
                 currentItem.Settings && compareItem.Settings &&
                 currentItem.Settings.x === compareItem.Settings.x &&
                 currentItem.Settings.y === compareItem.Settings.y &&
                 currentItem.index === compareItem.index;
        }

        async function redraw(el) {
          if (!el || !el.parentNode)
            return;

          let node = d3.select(el.parentNode);

          node.attr("transform", (d, i) => "translate(" + [ d.x || 0, d.y || 0 ] + ")scale(" + d.scale + ")");

          let handleRadius = 12;

          node.select('.reduction-scar')
              .attr('stroke-dasharray', d => selected(d) ? [ 5, 5 ] : '')
              .attr('stroke', d => {
                if (selected(d)) {
                  return 'green';
                }
                const itemColor = getItemColor(d.item);
                return itemColor || 'black';
              })
              .attr('stroke-width', d => 1 / d.scale * 2)

          node.select('.dragHandle, .selectProblem')
              .attr('stroke-dasharray', d => selected(d) ? [ 5, 5 ] : '')
              .attr('stroke', d => {
                if (selected(d)) {
                  return 'green';
                }
                const itemColor = getItemColor(d.item);
                return itemColor || 'black';
              })
              .attr('stroke-width', d => 1 / d.scale * 4 + .5)

          node.select('.dragright')
              .attr('opacity', d => selected(d) ? 1 : 0)
              .attr('visibility', d => selected(d) ? 'visible' : 'hidden')
              .attr('transform', d => {
                const translate = [ (d.scale - 1) * d.origWidth / 2, 0 ];
                return "scale(" + 1 / d.scale + ")translate(" + translate + ")";
              });

          node.select('.bartop')
              .attr('opacity', d => selected(d) ? 1 : 0)
              .attr('visibility', d => selected(d) ? 'visible' : 'hidden')
              .attr('transform', d => {
                const translate = [ 0, -(d.scale - 1) * d.height / 2 ];
                if (d.y - d.height * d.scale / 2 < 35) {
                  translate[ 1 ] += 35 - (d.y - d.height * d.scale / 2);
                }
                const effectiveType = getEffectiveType(d.item);
                if (effectiveType === 'Mastectomy') {
                  translate[ 1 ] = 50;
                }
                else if (effectiveType === 'ReductionScar') {
                  translate[ 0 ] = 50;
                  translate[ 1 ] = 80;
                }
                return "scale(" + 1 / d.scale + ")translate(" + translate + ")";
              });

          node.select('.barLabel')
              .attr('font-size', '15px')
              .attr('font-family', 'sans-serif')
              .attr('transform', d => "scale(" + 1 / d.scale + ")")
              .attr("x", d => {
                const effectiveType = getEffectiveType(d.item);
                if (effectiveType === 'Square') {
                  return -(d.origHeight / 2 * d.scale) - 10;
                }
                if (effectiveType === 'Mastectomy') {
                  return -(d.origHeight / 2 * d.scale) - 25;
                }
                if (effectiveType === 'ReductionScar') {
                  return -(d.origHeight / 2 * d.scale) + 70;
                }
                return -(d.origHeight / 2 * d.scale) - 5;
              })
              .attr("y", d => {
                const effectiveType = getEffectiveType(d.item);
                if (effectiveType === 'Square') {
                  return -(d.origWidth / 2 * d.scale) - 10;
                }
                if (effectiveType === 'Mastectomy') {
                  return -(d.origHeight / 2 * d.scale) + 40;
                }
                if (effectiveType === 'ReductionScar') {
                  return -(d.origHeight / 2 * d.scale) + 80;
                }
                return -(d.origWidth / 2 * d.scale) - 5;
              })
              .text(d => d.item.index);

          node.datum().item.Settings = getPosition(node);
        }

        function drawScar(path) {
          scope.$apply(() => {
            scope.drawScar(path);
          });
        }

        function getLine() {
          let line = d3.svg.line()
                       .interpolate("linear")
                       .x((d, i) => (d || [ 0, 0 ])[ 0 ])
                       .y((d, i) => (d || [ 0, 0 ])[ 1 ]);

          return line;
        }
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/directives/diagramEditor.js